/**
 * Sticky Offset Coordinator
 * Centralized manager for all fixed/sticky section offset contributions.
 * Each sticky section registers its height; the coordinator sums them,
 * writes --untamed-fixed-header-offset once, and dispatches an event.
 */
(function() {
  if (window.UntamedStickyOffset) return;

  var contributions = {};
  var orderedKeys = [];
  var sectionRefs = {};

  function isElement(node) {
    return !!(node && node.nodeType === 1);
  }

  function getOrderFor(id) {
    var sectionEl = sectionRefs[id];
    if (isElement(sectionEl) && sectionEl.isConnected) {
      var sections = document.querySelectorAll('.shopify-section');
      for (var i = 0; i < sections.length; i++) {
        if (sections[i] === sectionEl) return i;
      }
    }
    var idx = orderedKeys.indexOf(id);
    if (idx !== -1) return 1000 + idx;
    return Number.MAX_SAFE_INTEGER;
  }

  function effectiveOrder() {
    var keys = Object.keys(contributions);
    keys.sort(function(a, b) {
      var ao = getOrderFor(a);
      var bo = getOrderFor(b);
      if (ao !== bo) return ao - bo;
      return orderedKeys.indexOf(a) - orderedKeys.indexOf(b);
    });
    return keys;
  }

  function sum() {
    var total = 0;
    var keys = effectiveOrder();
    for (var i = 0; i < keys.length; i++) {
      total += (contributions[keys[i]] || 0);
    }
    return total;
  }

  function apply() {
    var total = sum();
    if (total > 0) {
      document.documentElement.classList.add('untamed-has-fixed-header');
      document.documentElement.style.setProperty('--untamed-fixed-header-offset', total + 'px');
    } else {
      document.documentElement.classList.remove('untamed-has-fixed-header');
      document.documentElement.style.removeProperty('--untamed-fixed-header-offset');
    }
    window.dispatchEvent(new CustomEvent('untamed:offset-changed', { detail: { total: total, instant: window.UntamedStickyOffset._instant || false } }));
  }

  window.UntamedStickyOffset = {
    register: function(id, heightPx, sectionEl) {
      var val = Math.max(Math.ceil(heightPx), 0);
      if (orderedKeys.indexOf(id) === -1) {
        orderedKeys.push(id);
      }
      if (isElement(sectionEl)) {
        sectionRefs[id] = sectionEl;
      }
      contributions[id] = val;
      apply();
    },

    unregister: function(id) {
      if (!(id in contributions)) return;
      delete contributions[id];
      delete sectionRefs[id];
      apply();
    },

    setContribution: function(id, heightPx) {
      if (!(id in contributions)) return;
      contributions[id] = Math.max(Math.ceil(heightPx), 0);
      apply();
    },

    animatingOffsets: false,
    _instant: false,

    getTotal: function() {
      return sum();
    },

    getContribution: function(id) {
      return contributions[id] || 0;
    },

    getOffsetBefore: function(id) {
      var total = 0;
      var keys = effectiveOrder();
      if (id in contributions) {
        for (var i = 0; i < keys.length; i++) {
          if (keys[i] === id) break;
          total += (contributions[keys[i]] || 0);
        }
        return total;
      }

      var targetOrder = getOrderFor(id);
      if (targetOrder === Number.MAX_SAFE_INTEGER) {
        for (var j = 0; j < keys.length; j++) {
          total += (contributions[keys[j]] || 0);
        }
        return total;
      }

      for (var k = 0; k < keys.length; k++) {
        if (getOrderFor(keys[k]) < targetOrder) {
          total += (contributions[keys[k]] || 0);
        }
      }
      return total;
    }
  };
})();
